import { Injectable, NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import {
  DefaultDataServiceConfig,
  DefaultHttpUrlGenerator,
  EntityDataModule,
  EntityDataService,
  HttpResourceUrls,
  HttpUrlGenerator
} from '@ngrx/data';
import { entityConfig } from './store/entity-metadata';
import {
  ConversationsCollectionService,
  MessagesCollectionService,
  ParticipantsCollectionService,
  SettingsCollectionService,
  UsersCollectionService,
  UsersDataService
} from './store/store-services';
import { environment } from '../environments/environment';
import { StateEntity } from './store/entity.constants';

const defaultDataServiceConfig: DefaultDataServiceConfig = {
  root: `${environment.apiUrl}`,
  timeout: 0, // infinite request timeout
};

@Injectable({providedIn: 'root'})
export class CustomHttpUrlGenerator extends DefaultHttpUrlGenerator {
  protected getResourceUrls(entityName: string, root: string): HttpResourceUrls {

    switch (entityName) {
      case StateEntity.User:
        return {
          collectionResourceUrl: `${root}/v1/User/get-all-users`,
          entityResourceUrl: `${root}/v1/User/get-all-users`,
        };
    }

    return super.getResourceUrls(entityName, root);
  }
}

@NgModule({
  imports: [
    StoreModule.forRoot({}, {
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
        strictActionSerializability: true,
        strictActionWithinNgZone: true,
        strictActionTypeUniqueness: true,
        strictStateSerializability: false,
      }
    }),
    EffectsModule.forRoot([]),
    EntityDataModule.forRoot(entityConfig),
    ...(environment.production ? [] : [StoreDevtoolsModule.instrument()])
  ],
  providers: [
    {provide: DefaultDataServiceConfig, useValue: defaultDataServiceConfig},
    {provide: HttpUrlGenerator, useClass: CustomHttpUrlGenerator},
    UsersDataService,
    UsersCollectionService,
    SettingsCollectionService,
    ConversationsCollectionService,
    ParticipantsCollectionService,
    MessagesCollectionService,
  ],
  exports: [
    StoreModule,
    EffectsModule,
    EntityDataModule,
    ...(environment.production ? [] : [StoreDevtoolsModule])
  ],
})
export class AppStoreModule {
  constructor(
    private entityDataService: EntityDataService,
    private usersService: UsersDataService,
  ) {
    entityDataService.registerService(StateEntity.User, usersService);
  }
}
